import { ReactNode } from 'react'

import { useSeller } from '@/contexts/seller'

import SplitControl from '@/components/business/SplitControl'

import NotFound from '@/pages/NotFound'

type Props = {
  children: NonNullable<ReactNode>
}

const SplitHandler = ({ children }: Props) => {
  const { hasTwinSeller } = useSeller()

  return hasTwinSeller ? (
    children
  ) : (
    <SplitControl splitName="scheduled_orders_beta" treatmentOff={<NotFound />}>
      {children}
    </SplitControl>
  )
}

export default SplitHandler
